module.exports = __webpack_public_path__ + "img/background.c254b1d2.png";